import { ContactDetailsFormProps } from '@/src/components/common/forms/contactDetailsForm'
import { Customer } from '@/src/types/itinerary'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useGetSaveTravelerData } from '../../useLoadUserData'

export const useContactDetails = (customer: Customer) => {
    const { userData } = useGetSaveTravelerData()
    const defaultMobileCountryCode = '966' // saudi arabia
    const initialContactDetails: Customer = useMemo(() => {
        return {
            ...customer,
            email: customer.email || userData?.customer?.email || '',
            mobile: customer.mobile || '',
            mobileCountryCode: customer.mobileCountryCode || defaultMobileCountryCode
        }
    }, [customer, userData?.customer])

    const [contactDetails, setContactDetails] = useState<Customer>(initialContactDetails)

    const onChangeContactDetails: ContactDetailsFormProps['onChange'] = useCallback((key, value) => {
        setContactDetails(prev => ({
            ...prev,
            [key]: value
        }))
    }, [])

    useEffect(() => {
        if (userData?.customer?.email && !contactDetails.email) {
            setContactDetails(prev => ({
                ...prev,
                email: userData?.customer?.email || ''
            }))
        }
    }, [userData?.customer])

    return {
        contactDetails,
        setContactDetails,
        onChangeContactDetails
    }
}
